const initialState = {
  // `null` and not `0`: an unread balance and an empty wallet look identical as a number, and the
  // badge must not flash "0 credits" at somebody who has plenty while the first request is in
  // flight. Components check for null before rendering an amount.
  credits: null,
  daily: { amount: 0, claimable: false, nextClaimAt: null },
  gameEntryCost: null,
  history: [],

  // Which classes this account may take into a lobby. It arrives with the wallet rather than with
  // the shop, because the lobby needs it and most sessions never open the shop.
  unlockedRaces: [],
  // And which looks and reactions. Same request, same reason.
  ownedCosmetics: [],

  // The catalogue, loaded when the shop is opened.
  races: [],
  packs: [],
  cosmetics: [],
  currency: "EUR",
  purchasesEnabled: false,
  shopLoaded: false,
}

export default initialState
